import { useIsAdminOrDev } from "@/auth/roles";

export const useIsDownloadsEnabled = () => {
  return useIsAdminOrDev();
};

export const useIsMedianPriceEnabled = () => {
  return useIsAdminOrDev();
};
